export const searchHeaderStyle = {
	wrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: '12px',
		padding: '0 16px',
		width: '100%',

		'@media (max-width: 639.98px)': {
			padding: '0 20px',
		},
	},

	title: {
		color: 'var(--neutral-500)',
		lineHeight: '20px',
	},

	actions: {
		display: 'flex',
		gap: '16px',
		width: '100%',
		justifyContent: 'flex-end',
		marginLeft: 'auto',

		'@media (max-width: 639.98px)': {
			flexDirection: 'row-reverse',
			justifyContent: 'flex-end',
		},
	},

	search: {
		width: '300px',
		backgroundColor: 'rgba(240, 241, 244, 0.50)',
		borderRadius: '8px',
		minWidth: 'unset',

		'@media (max-width: 768px)': {
			minWidth: 'unset',
			width: '100%',
		},

		'& fieldset': {
			border: 'unset !important',
		},
	},
};
